// 全局配置
import { configure, getConfig } from 'choerodon-ui';
import { Tooltip } from 'choerodon-ui/pro/lib/core/enum';
import { getSession } from 'hzero-front/lib/utils/utils';
import { debounce, floor, omit } from 'lodash';
// 项目JS入口文件
import EventBus, { EventTypes } from '@common/utils/event-bus';
import Report from '@common/utils/report';
import { getMenuPathAndExtractByKey, performanceReportDefered } from '@common/utils/report/utils/helpers';
import { setSession, getCurrentUser } from 'utils/utils';
import ExtraHeaderRight from './ExtraHeaderRight';
import './globalWindowFunc.ts';
import BeaconAction from './tgp_h5_sdk.min.js';

import { AddTabHook, ChangeDateTimeFormatterHook, InitHooks, UserLoginHook, UserLogoutHook } from './utils/dva-hooks';
import { globalConfigure } from './utils/configure';

const clientId = process.env.CLIENT_ID;
const BASE_PATH = process.env.BASE_PATH as string;
// 初始化事件总线
EventBus.init();
Report.config({
  performanceCore: true,
  performanceFirstResource: true,
  performanceServer: true,
  errorServer: false,
  openErrorReport: true,
  openBehaviourReport: true,
});

// 开始埋点上报
Report.instance.startReport();
// 监听新打开menuTab事件
EventBus.emitter.on(EventTypes.ADD_TAB, data => {
  const { key } = data.newTab;
  if (key && key.indexOf('/link/') === -1) {
    const queryParams = getSession('queryParams');
    if (queryParams) {
      // 新打开menuTab，先清除一下页面缓存的查询数据
      const menuKeys = Object.keys(queryParams).filter(
        k =>
          !k
            .replace(BASE_PATH, '/')
            .replace('//', '/')
            .indexOf(key)
      );
      setSession('queryParams', omit(queryParams, menuKeys));
    }
  }
});

// 监听标签页变化事件
let pObserver: PerformanceObserver;
let mObserver: MutationObserver;
EventBus.emitter.on(EventTypes.ACTIVE_TAB_CHANGE, data => {
  const menus = getMenuPathAndExtractByKey('title', data.nextTabKey);
  if (menus.length > 0) {
    Report.instance.beacon.addAdditionalParams({
      pageFirstMenu: menus[0],
      pageSecondMenu: menus[1],
      pageThirdMenu: menus.length > 2 ? menus[2] : '',
    });
    performanceReportDefered.setReady('menu');
    if (pObserver) {
      pObserver.disconnect();
    }
    if (mObserver) {
      mObserver.disconnect();
    }
    let renderStartTime = 0;
    let isFirst = false;
    const calculator = debounce(() => {
      if (!isFirst) {
        console.log(
          '【页面渲染时间】',
          menus[0],
          menus[1],
          menus.length > 2 ? menus[2] : '',
          performance.now() - renderStartTime
        );
        isFirst = true;
      }
      if (pObserver) {
        pObserver.disconnect();
      }
      if (mObserver) {
        mObserver.disconnect();
      }
      Report.instance.beacon.onUserAction('page_render_duration_event', {
        pageDuration: floor(performance.now() - renderStartTime, 2),
        actionType: data.actionType,
      });
    }, 300);
    pObserver = new PerformanceObserver(calculator);

    const ele = document.querySelector('.ant-tabs-tabpane-active');
    if (ele) {
      mObserver = new MutationObserver(calculator);

      mObserver.observe(ele, {
        subtree: true,
        // 目标以及目标的后代改变都会观察
        childList: true,
        // 表示观察目标子节点的变化，比如添加或者删除目标子节点，不包括修改子节点以及子节点后代的变化
        attributes: false, // 观察属性变动
        // attributeFilter: ['src', 'href'], // 要观察的属性
      });
    }

    pObserver.observe({
      entryTypes: ['resource'],
    });
    renderStartTime = performance.now();
  }
});

// 监听新打开menuTab事件
EventBus.emitter.on(EventTypes.ADD_TAB, data => {
  const menus = getMenuPathAndExtractByKey('title', data.newTab.key);
  if (menus.length > 0) {
    Report.instance.beacon.onUserAction('c_page_report_event', {
      pageFirstMenu: menus[0],
      pageSecondMenu: menus[1],
      pageThirdMenu: menus.length > 2 ? menus[2] : '',
    });
  }
});
// declare global{
//   interface Window {
//     businessOperate: any;
//   }
// }
// import 'antd/dist/antd.css';
// Key  3e7e415b1d6b23d8f3c0d46b2e4ff57c
// 安全密钥  a76c7a1ec8fdef137fb00bdf94afb2cd
const insertMapScript = () => {
  console.log('_AMapSecurityConfig_AMapSecurityConfig');
  (window as any)._AMapSecurityConfig = {
    securityJsCode: 'a76c7a1ec8fdef137fb00bdf94afb2cd',
  };
  const jsapi = document.createElement('script');
  jsapi.src = 'https://webapi.amap.com/loader.js';
  document.head.appendChild(jsapi);
};
const insetScript = () => {
  if (window.JSPlugin) return;
  const script = document.createElement('script');
  script.src = '/h5player.min.js';
  document.head.appendChild(script);
};
const layoutExtraHeader = () => {
  return ExtraHeaderRight();
};

// 上报成功回调，可根据实际业务调整，这里给到一种打印到控制台的方案
const success = e => {
  // console.log(`report onReportSuccess :  + ${e}`);
};
// 上报失败回调，可根据实际业务调整，这里给到一种打印到控制台的方案
const fail = e => {
  // console.log(`report onReportFail :  + ${e}`);
};
export { layoutExtraHeader };
const redirectData = () => {
  const info = getCurrentUser();
  const type = info?.additionInfo?.businessCustomer?.type;
  if (type === 'operator') {
    // 个人
    return [
      {
        from: '',
        to: '/monitor/index',
      },
    ];
  }
  return [
    {
      from: '',
      to: '/order/change',
    },
  ];
};
const dvaAppInit = app => {
  layoutExtraHeader();
  globalConfigure();
  // 注册Dva插件
  app.use({
    onAction: [UserLoginHook(), AddTabHook(), UserLogoutHook(), ChangeDateTimeFormatterHook(), InitHooks()],
  });
  insertMapScript();
  insetScript();
  require('./historianTrace.js');
  require('./echartTheme.js');
  // setLayout('company-horizontal', async () => import('sany-cbms-front-common/src/layouts/CustomLayout.tsx'));
  require('./global.module.less');
};

const preLoadPromptCodes = [
  'hzero.common',
  'cbms.common',
  'cbms.often',
  'cbms.other',
  'cbms.rare',
  'sany.common',
  'order.change',
  'monitor.batterymonitor',
  'monitor.allmonitor',
  'monitor.index',
];
export default { dvaAppInit, redirectData, defaultLoadLocale: preLoadPromptCodes.join(',') };
